import { mapActions } from 'vuex'

// 方式一：
const ACTION_PREFIX = module.id // 设置action前缀确保type的唯一性
// console.log('ACTION_PREFIX', ACTION_PREFIX)
export const LOAD_DATA = `${ACTION_PREFIX}LOAD_DATA`
export default mapActions({
  loadData: LOAD_DATA
})

// 方式二：
// const ACTION_PREFIX = 'app/' // 在每个module中设置namespaced: true
// export const LOAD_DATA = 'LOAD_DATA'

// export default mapActions({
//   loadData: `${ACTION_PREFIX}LOAD_DATA`
// })



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js